import { PropsWithChildren } from "react";
import { KeyboardAwareScrollView } from "react-native-keyboard-aware-scroll-view";
import { createStyles, sizes, ThemeSize } from "../theme";

type Props = PropsWithChildren<{
  p?: ThemeSize;
  small?: boolean;
}>;

export function Form({ children, p, small = false }: Props) {
  const paddingSize = p ?? (small ? "8" : "4");

  return (
    <KeyboardAwareScrollView
      bounces={false}
      contentContainerStyle={[
        $.content,
        small && $.small,
        { padding: sizes[paddingSize] },
      ]}
      keyboardShouldPersistTaps="handled"
    >
      {children}
    </KeyboardAwareScrollView>
  );
}

const $ = createStyles({
  content: {
    flexGrow: 1,
  },
  small: {
    flexDirection: "column",
    justifyContent: "flex-end",
  },
});
